// Library Import
import React, { useState } from "react";
import {
  Box,
  Button,
  Collapse,
  Flex,
  Icon,
  Image,
  Text,
  useBoolean,
  useDisclosure,
} from "@chakra-ui/react";

// Icon Imports
import { FaTasks } from "react-icons/fa";
import { HiCode } from "react-icons/hi";
import { MdHome, MdKeyboardArrowRight, MdModeEdit } from "react-icons/md";
import { MdDeleteForever } from "react-icons/md";
import { RiFileExcel2Line } from "react-icons/ri";

// Local Imports
import CCLOGOFULL from "../../assets/CCLOGOFULL.png";
import { useDispatch } from "react-redux";
import { redLogout } from "../../redux/slices/adminSlice";

const Sidebar = ({ setScreenType, ...sidebarProps }) => {
  const dispatch = useDispatch();
  const integrations = useDisclosure();

  const [homeBut, setHomeBut] = useBoolean(false);
  const [addTaskBut, setAddTaskBut] = useBoolean(false);
  const [editTaskBut, setEditTaskBut] = useBoolean(false);
  const [deleteUserBut, setDeleteUserBut] = useBoolean(false);
  const [excelUploadUserBut, setExcelUploadUserBut] = useBoolean(false);

  const NavItem = (props) => {
    const { icon, children, iconSize, ...rest } = props;
    const [active, setActive] = useBoolean();

    return (
      <Flex
        align="center"
        px="4"
        pl="4"
        py="3"
        cursor="pointer"
        color="gray.600"
        _hover={{
          bg: "gray.100",
          color: "gray.900",
        }}
        role="group"
        fontWeight="semibold"
        transition=".15s ease"
        {...rest}
      >
        {icon && (
          <Icon
            mx="2"
            fontSize={iconSize ? iconSize : "15px"}
            _groupHover={{
              color: "gray.600",
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    );
  };

  const activateButton = (type) => {
    setHomeBut.off();
    setAddTaskBut.off();
    setEditTaskBut.off();
    setDeleteUserBut.off();
    setExcelUploadUserBut.off();

    if (type === "home") {
      setHomeBut.on();
    } else if (type === "addTask") {
      setAddTaskBut.on();
    } else if (type === "EditTask") {
      setEditTaskBut.on();
    } else if (type === "deleteUser") {
      setDeleteUserBut.on();
    } else if (type === "excelUploadUser") {
      setExcelUploadUserBut.on();
    }
  };

  return (
    <Box
      as="nav"
      pos="fixed"
      top="0"
      left="0"
      zIndex="sticky"
      h="full"
      pb="10"
      overflowX="hidden"
      overflowY="auto"
      bg="white"
      border
      color="inherit"
      borderRightWidth="1px"
      w="60"
      {...sidebarProps}
    >
      <Flex px="4" py="5" align="center">
        <Image src={CCLOGOFULL} w="170px" />
      </Flex>
      <Flex
        direction="column"
        as="nav"
        fontSize="sm"
        color="gray.600"
        aria-label="Main Navigation"
      >
        {homeBut ? (
          <NavItem icon={MdHome} bg={"gray.100"}>
            Home
          </NavItem>
        ) : (
          <NavItem
            icon={MdHome}
            onClick={() => {
              activateButton("home");
              setScreenType("home");
            }}
          >
            Home
          </NavItem>
        )}

        {deleteUserBut ? (
          <NavItem icon={MdDeleteForever} bg={"gray.100"}>
            Delete User
          </NavItem>
        ) : (
          <NavItem
            icon={MdDeleteForever}
            onClick={() => {
              activateButton("deleteUser");
              setScreenType("deleteUser");
            }}
          >
            Delete User
          </NavItem>
        )}

        {excelUploadUserBut ? (
          <NavItem icon={RiFileExcel2Line} bg={"gray.100"}>
            Excel upload
          </NavItem>
        ) : (
          <NavItem
            icon={RiFileExcel2Line}
            onClick={() => {
              activateButton("excelUploadUser");
              setScreenType("excelUploadUser");
            }}
          >
            Excel upload
          </NavItem>
        )}

        <NavItem icon={MdDeleteForever}>
          <Box width="100%" height="100%" onClick={() => dispatch(redLogout())}>
            <Text color="red">Logout</Text>
          </Box>
        </NavItem>
      </Flex>
    </Box>
  );
};

export default Sidebar;
